import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const categoryService = {
  getAllCategories,
  addCategory,
  getCategory,
  deleteCategory
};

function getAllCategories(params) {
  return apiCall("GET", apiUrls.categories.base, null, params);
}

function addCategory(request, id) {
  const method = id ? "PUT" : "POST";
  let url = apiUrls.categories.base;
  !!id && (url = `${url}/${id}`);
  return apiCall(method, url, request);
}

function getCategory(id) {
  return apiCall("GET", `${apiUrls.categories.base}/${id}`);
}

function deleteCategory(id) {
  return apiCall("DELETE", `${apiUrls.categories.base}/${id}`);
}
